<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
export default {
  name: "App",
  created() {
    // document.title = "学科网AI智能平台";
    const cacheStore = window.sessionStorage.getItem("store");
    if (cacheStore) {
      this.$store.replaceState(Object.assign({}, this.$store.state, JSON.parse(cacheStore)));
    }
    window.addEventListener("beforeunload", () => {
      window.sessionStorage.setItem("store", JSON.stringify(this.$store.state));
    });
  },
};
</script>
<style>
@import "./assets/styles/common.scss";
</style>
